import { Badge } from '@/components/ui/badge'
import {
  KNOWLEDGE_BASE_FOLDER_SOURCE_TYPE_WEBSITE,
  KNOWLEDGE_BASE_SOURCE_TYPE_LEARNED,
  type KnowledgeBaseFolderSourceType,
} from '@/lib/ai/knowledge-base/folder-types'
import { useTranslations } from "next-intl"


/** Where a folder's documents come from, for the folders the platform fills; none for a person's own. */
export function FolderSourceBadge({ sourceType }: { sourceType: KnowledgeBaseFolderSourceType }) {
  const tUi = useTranslations("Ai.AiKnowledgeBaseFolderSourceBadge")

  const tSources = useTranslations('KnowledgeSources')

  switch (sourceType) {
    case KNOWLEDGE_BASE_FOLDER_SOURCE_TYPE_WEBSITE:
      return <Badge variant="secondary"><span key={tUi("website")}>{tUi("website")}</span></Badge>
    case KNOWLEDGE_BASE_SOURCE_TYPE_LEARNED:
      return <Badge variant="secondary"><span key={tUi("learned")}>{tUi("learned")}</span></Badge>
    case 'google_drive':
      return <Badge variant="secondary"><span>{tSources('connectedFiles')}</span></Badge>
    default:
      return null
  }
}
